
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"29","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#409FFF","stroke-width":"1.8","d":"M.9.9h26.417v18.722H.9z"}}),_c('path',{attrs:{"d":"M11.781 16.212a7.789 7.789 0 00-7.715 6.723c-.122.893.62 1.565 1.428 1.565h12.575c.806 0 1.55-.672 1.427-1.565a7.789 7.789 0 00-7.715-6.723zM12.072 15.9a5.055 5.055 0 100-10.109 5.055 5.055 0 000 10.11z","fill":"#fff","stroke":"#fff"}}),_c('path',{attrs:{"d":"M5.494 23.1a.092.092 0 01-.037-.007 6.389 6.389 0 0112.648 0 .092.092 0 01-.037.007H5.495zM15.727 10.846a3.655 3.655 0 11-7.31 0 3.655 3.655 0 017.31 0z","fill":"#fff","stroke":"#409FFF","stroke-width":"1.8"}})])
          )
        }
      }
    